<template>
  <ui-dialog
    :title="title | uppercase"
    :isLoading="isLoading"
    :isVisible.sync="isVisible"
    :class="['dialog-scroll']"
    :customClass="customClass"
    @close="handlerClose">
    <vue-custom-scrollbar class="dialog-scroll__scroll">
      <div class="dialog-scroll__scroll-view">
        <div class="dialog-scroll__scroll-inner">
          <slot></slot>
        </div>
      </div>
    </vue-custom-scrollbar>
    <template v-slot:footer>
      <slot name="footer"></slot>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: 'DialogInfo',
  props: {
    title: { type: String },
    isLoading: { type: Boolean },
    customClass: { type: String, default: '' }
  },
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Dialogs' */ './Dialog')
  },
  data () {
    return {
      isVisible: false
    }
  },
  methods: {
    show () {
      this.isVisible = true
    },
    hide () {
      this.isVisible = false
    },
    handlerClose () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="stylus">
  .dialog-scroll{
    &__scroll{
      position relative
      height 100%
    }
    &__scroll-view{
      position absolute
      top 0
      left 0
      right 15px
      bottom 0
    }
    &__scroll-inner{
      min-height 100%
      height 1px
    }
    .el-dialog{
      margin 6rem auto!important
      height calc(100% - 12rem)
      display flex
      flex-direction column
      width 100%
      max-width 120rem
      &__body{
        flex 1
      }
    }
  }
</style>
